module.exports = __webpack_public_path__ + "img/logo-credit-cards.e4d6d571.png";